import React, { Component } from 'react'
import styled from 'styled-components'
import { Title } from 'advenio-components'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
// import { QrReader } from 'react-qr-reader'
// import QrReader from 'react-qr-scanner'
import { isEmpty, isNil } from 'ramda'

/** Components **/
import ErrorIsland from '../../Components/ErrorIsland'
import ModalAssessment from '../../Components/ModalContainer/ModalAssessment'
import CheckInModal from '../../Components/ModalContainer/CheckInModal'
/** Data **/
import HealthCheckActions from '../../Data/Redux/HealthCheckRedux'
import CenterClassroomActions from '../../Data/Redux/CenterClassroomRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import CenterActions from '../../Data/Redux/CenterRedux'
import InventoryActions from '../../Data/Redux/InventoryRedux'
/** Tools **/
import { parseFullName } from '../../utils/Utils'
import { QrReader } from 'react-qr-reader'

const Container = styled.div`
  padding: 54px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const QrContainer2 = styled.div`

`
const QrContainer = styled.div`
  display: flex;
  justify-content: center;
`

const ErrorRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px;
`

class TestQr extends Component {
  state = {
    data: null,
    scan: true,
    error: null,
    width: 0,
    mLeft: 0,
    assessment: false,
    child: {},
    isVirtual: false,
    disabledVirtual: false,
    checkOut: false,
  }

  componentWillMount = () => {
    let width = window.innerWidth
    const { user, getCenters } = this.props

    width = width > 700 ? width / 2 : width / 2
    let mLeft = width / 2 / 2 / 2
    this.setState({ width, mLeft })
    getCenters()
    if (user && user.center_id) {
      this.props.getCenterClassroom(user.center_id)
    }

  }

  componentWillReceiveProps (nextProps) {
  }

  handleScan = (data) => {
    if (!isNil(data)) {

      const {
        classrooms,
        user,
        setActiveCenterId,
        setActiveStudentId,
        students,
      } = this.props
      let info = {}
      try {
        info = JSON.parse(data.text)

      } catch (ex) {
        this.setState({ error: ex.message })
        return
      }
      const classroom = classrooms.filter(c => c.id === info.classroom_id)
      let scan, isVirtual = false
      let assessment, checkOut = false
      let child = {}
      let error = null
      if (isNil(info.id)) {
        scan = true
        error = 'Error al intentar Leer el QR.'
        this.setState(
          { data: info, child, scan, assessment, isVirtual, error, checkOut })

        return
      }
      setActiveCenterId(info.center_id)
      setActiveStudentId(info.id)
      if (!isEmpty(classroom)) {
        child = classroom[0].students.filter(s => s.id === info.id)[0]
        this.props.setActiveClassroomId(info.classroom_id)
        if (!isEmpty(child)) {
          if (!isNil(child.checkin.id)) {
            checkOut = true
          } else {
            assessment = true
          }
        }
      } else {
        if (user.role !== 'Teacher') {
          let student = students.filter(s => s.student.id === info.id)
          if (!isEmpty(student)) {
            checkOut = true
            child = student[0].student
            let classroomVirtual = classrooms.filter(
              c => c.name === student[0].classroom)[0]
            this.props.setActiveClassroomId(classroomVirtual.id)
          } else {
            isVirtual = true
            assessment = true
            scan = false
            child = info
          }
        } else {
          scan = true
          error = 'No puedes dar Checkin a este alumno: ' + parseFullName(info)
        }
      }
      this.setState(
        { data: info, child, scan, assessment, isVirtual, error, checkOut })

    }
  }

  handleError = (err) => {
    console.log(err)
  }

  closeAssessment = () => this.setState(
    { assessment: false, scan: true, child: {} })
  closeCheckOut = () => this.setState(
    { checkOut: false, scan: true, child: {} })

  // reader = (data) => {
  //   console.log(data);
  //   // window.location.replace(data)
  //   this.setState({data})

  // }
  render () {

    const {
      data,
      error,
      width,
      mLeft,
      assessment,
      child,
      isVirtual,
      scan,
      checkOut,
    } = this.state
    const {
      studentHomeReport,
      healthCheck: { Extra, Revise },
      healthCheck,
      healthCheckResponse,
      postChildVirtualHealthCheck,
      postChildHealthCheck,
      sendingHealthcheck,
      centerClassroom,
      classrooms,
      user,
    } = this.props

    return (
      <Container>
        <HeaderContainer>
          <Title>Scanner Qr</Title>
        </HeaderContainer>
        {error && (
          <ErrorRow>
            <ErrorIsland error={error}/>
          </ErrorRow>)}
        {(scan && classrooms.length > 0) && (
          <QrContainer2>
            {/* <p>{data}</p> */}
            <QrReader
              onResult={(result, error) => {
                if (!!result) {
                  // setData(result?.text);
                  // this.setState({data:result.text});
                  this.handleScan(result)
                  return
                }
              }}
              scanDelay={1500}
              constraints={{ facingMode: 'environment' }}
              videoContainerStyle={{
                width: `${width}px`,
                paddingTop: '50%',
                marginLeft: `${mLeft}px`,
              }}
            />
          </QrContainer2>
          // <QrContainer>
          //   jose
          //   <QrReader
          //     delay={1500}
          //     style={{width:width}}
          //     onError={this.handleError}
          //     onScan={this.handleScan}
          //     facingmode={'environment'}
          //     // choosedeviceid={1}
          //     // maximagesize={500}
          //   />
          // </QrContainer>
        )}
        <ModalAssessment
          open={assessment}
          child={child}
          closeAssessment={this.closeAssessment}
          extra={Extra}
          revise={Revise}
          askParent={healthCheck['Ask Parent']}
          postChildVirtualHealthCheck={postChildVirtualHealthCheck}
          postChildHealthCheck={postChildHealthCheck}
          isTeacher={user.role === 'Teacher'}
          healthCheckResponse={healthCheckResponse}
          centerClassroom={centerClassroom}
          virtual={isVirtual}
          loading={sendingHealthcheck}
          studentHomeReport={studentHomeReport}
        />
        <CheckInModal
          open={checkOut}
          child={child}
          closeCheckIn={this.closeCheckOut}
          closeCheckOut={this.closeCheckOut}
          consumables={[]}
          accessories={[]}
          postStudentCheckIn={() => {console.log('checkin')}}
          updateCheckinInventory={() => {console.log('chechkinInventory')}}
          postStudentCheckOut={this.props.postStudentCheckOut}
          isTeacher={user.role === 'Teacher'}
          type={'checkout'}
          studyPrograms={[]}
          loading={false}
        />
      </Container>
    )
  }
}

TestQr.defaultProps = {
  classrooms: [],
}

const mapStateToProps = state => ({
  healthCheck: state.healthCheck.get.results,
  healthCheckResponse: state.healthCheck,
  centerClassroom: state.centerClassroom.get.results,
  sendingHealthcheck: state.healthCheck.sending.fetching,
  studentHomeReport: state.home_report.student_home_report.result,
  classrooms: state.classrooms.get.results,
  students: state.classrooms.totalStudents,
  user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({
  postChildVirtualHealthCheck: (id, info) =>
    dispatch(
      // console.log("🚀 ~ file: TestQr.jsx:166 ~ mapDispatchToProps ~ id, info:", id, info)
      HealthCheckActions.postVirtualHealthCheckRequest(id, info),
    ),
  postChildHealthCheck: (id, info, isTeacher) =>
    dispatch(
      // console.log("🚀 ~ file: TestQr.jsx:172 ~ mapDispatchToProps ~ id, info, isTeacher:", id, info, isTeacher)
      HealthCheckActions.postHealthCheckRequest(id, info, isTeacher),
    ),
  postStudentCheckOut: (checkin_id, info, isTeacher) => dispatch(
    InventoryActions.postCheckOutRequest(checkin_id, info, isTeacher)),
  getCenterClassroom: id => dispatch(
    CenterClassroomActions.getClassroomRequest(id)),
  getCenters: () => dispatch(CenterActions.getRequest()),
  setActiveClassroomId: id => dispatch(
    ClassroomActions.setActiveClassroomId(id)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setActiveCenterId: id => dispatch(CenterActions.setActiveCenterId(id)),
  goTo: path => dispatch(push(path)),

})

export default connect(mapStateToProps, mapDispatchToProps)(TestQr)



// WEBPACK FOOTER //
// ./src/Containers/TestQr/TestQr.jsx